<template>
    <section class="contact-form-section">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-lg-5 col-xl-4">
                    <div class="contact-form-title h2">
                        Kontaktiere uns
                    </div>
                    <div class="contact-description">
                        <p>Gerne beantworten wir all deine Fragen.</p>
                        <a href="tel:+492119462555" class="btn light-btn">Telefon: +49 (0)211 - 9462 55-5</a>
                    </div>
                    <div class="working-hours">
                        <strong>Bürozeiten:</strong> <br>Montag bis Freitag: 8:30 bis 17:00 Uhr
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import Dialog from './Dialog';
import { BASE } from '../services/endpoints';

export default {
    name: "ContactForm",
    components: {
        Dialog
    },
    data() {
        return {
            showDialog: false,
            dialogMessage: '',
            success: '<h4 class="success">Vielen Dank!</h4> <p>Deine Nachricht wurde an uns übermittelt. Wir werden dein Anliegen schnellstmöglich prüfen. In dringenden Fällen kannst du dich mit uns telefonisch in Verbindung setzen.</p>',
            error: '<h4 class="red">Ein Fehler ist aufgetreten!</h4> <p>Leider konnte deine Anfrage aus technischen Gründen nicht verarbeitet werden. Bitte versuche es später erneut. In dringenden Fällen kannst du uns telefonisch kontaktieren.</p>',
            form: {
                name: {
                    val: '',
                    valid: true,
                },
                phone: {
                    val: '',
                    valid: true,
                },
                email: {
                    val: '',
                    valid: true,
                },
                nachricht: {
                    val: '',
                    valid: true,
                },
                datenschutz: {
                    val: false,
                    valid: true
                },
                isValid: true,
            }
        }
    },
    methods: {
        validateForm() {

            if(this.form.name.val.trim() === '') {
                this.form.name.valid = false;
                this.form.isValid = false;
            }
            if(this.form.email.val.trim() === '' || !(/.+@.+/.test(this.form.email.val))) {
                this.form.email.valid = false;
                this.form.isValid = false;
            }
            if(this.form.nachricht.val.trim() === '') {
                this.form.nachricht.valid = false;
                this.form.isValid = false;
            }
            if(!this.form.datenschutz.val) {
                this.form.datenschutz.valid = false;
                this.form.isValid = false;
            }
            return this.form.isValid;
        },
        clearForm() {
            this.form = {
                name: {
                    val: '',
                    valid: true,
                },
                phone: {
                    val: '',
                    valid: true,
                },
                email: {
                    val: '',
                    valid: true,
                },
                nachricht: {
                    val: '',
                    valid: true,
                },
                datenschutz: {
                    val: false,
                    valid: true
                },
                isValid: true,
            }
        },
        clearValidation(input) {
            this.form[input].valid = true;
        },
        async submitForm() {
            console.log(BASE);
            this.form.isValid = true;
            if (!this.validateForm()) {
                return;
            }
            try {
                const response = await axios.post(BASE + '/contact/car_online_sales', {
                    email: this.form.email.val,
                    phone: this.form.phone.val,
                    name: this.form.name.val,
                    note: this.form.nachricht.val
                });
                
                if(response.status === 201) {
                    this.showDialog = true;
                    this.dialogMessage = this.success;
                    this.clearForm();
                    setTimeout(() => {
                        this.closeModal();
                    }, 3000);
                } else {
                    this.showDialog = true;
                    this.dialogMessage = this.error;
                    setTimeout(() => {
                        this.closeModal();
                    }, 3000);
                }
            } catch(error) {
                this.showDialog = true;
                this.dialogMessage = this.error;
                setTimeout(() => {
                    this.closeModal();
                }, 3000);
            }
        },
        closeModal() {
            this.showDialog = false;
        }
    }
}
</script>

<style lang="scss">
    @import "~@/assets/vars";
    .contact-form-section {
        background:$light-gray;
        padding-top:24px;
        padding-bottom:30px;

        @include breakpoint(frommediumlarge) {
            padding-top:50px;
            padding-bottom:65px;
        }

        @include breakpoint(fromgiant) {
            padding-top:94px;
            padding-bottom:100px;
        }

        .contact-form-title {
            @include breakpoint(extralarge) {
                white-space: nowrap;
            }
        }

        .contact-description {
            @include breakpoint(frommediumlarge) {
                display:flex;
                align-items: center;                
            }

            @include breakpoint(fromlarge) {
                display:block;
            }

            p {
                @include breakpoint(frommediumlarge) {
                    margin-bottom:0;
                    margin-right:30px;
                }
                @include breakpoint(fromgiant) {
                    margin-right:0;
                }
            }

            .btn {
                margin-top:12px;
                @include breakpoint(frommediumlarge) {
                    margin-top:0;
                }
                @include breakpoint(fromlarge) {
                    margin-top:12px;
                }
            }
        }

        fieldset {
            border:0 none;
            margin:0;
        }

        .error-message {
            color:$red;
        }

        .working-hours {
            margin-top:27px;
            font-size:18px;
            line-height:28px;

            br {
                @include breakpoint(frommediumlarge) {
                    display:none;
                }
                @include breakpoint(fromlarge) {
                    display:block;
                }
            }
        }

        form {
            margin-top:44px;
            @include breakpoint(frommediumlarge) {
                margin-top:50px;
            }
            @include breakpoint(fromlarge) {
                margin-top:0;
            }
            .form-field {
                display:block;
                margin-bottom:18px;

                &:last-of-type {
                    margin-bottom:0;
                }

                &.invalid {
                    input[type="text"],
                    input[type="email"],
                    input[type="tel"],
                    textarea {
                        border:1px solid $red;
                    }
                }

                label {
                    font-size:18px;
                    line-height: 28px;

                    a {
                        border-bottom:1px solid $red;

                        &:hover,
                        &:focus,
                        &:active {
                            border-bottom:1px solid transparent;
                        }
                    }
                }

                input[type="text"],
                input[type="email"],
                input[type="tel"],
                textarea {
                    border:0 none;
                    border-radius:0;
                    width:100%;
                    font-size: 18px;
                    line-height:24px;
                    font-style: italic;
                    padding:23px 24px;
                }

                &.textarea-field {
                    height:243px;
                    @include breakpoint(frommediumlarge) {
                        height:100%;
                    }
                    textarea {
                        height:243px;
                        @include breakpoint(frommediumlarge) {
                            height:100%;
                        }
                    }
                }

                &.checkbox {
                    margin-bottom:10px;
                }

                .fadeCheckbox {
                    position: relative;
                    display: flex;
                    width: 100%;
                    align-items: flex-start;
                    margin-top: 1.5rem;
                    padding: 0;
                    label {
                        width: calc(100% - 15px);
                        position: relative;
                        display: inline-block;
                        padding-left: 0;
                        order: 2;
                        margin-bottom: 0;

                        &.error {
                            position: absolute;
                            left: 0;
                            top: 140px;
                        }
                    }

                    label.custom-check {
                        width: 17px;
                        height: 16px;
                        position: relative;
                        display: inline-block;
                        margin-right: 1.2rem;
                        margin-top:7px;
                        order:1;
                        background: $white;
                        border: 1px solid $border-dark;
                        cursor: pointer;
                        padding: 0; 
                        min-height: 0;

                        &:after {
                            content: '✓';
                            color:$red;
                            display: block;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -100%);
                            opacity: 0;
                            transition: 300ms all;
                        }
                    }

                    input {
                        position:absolute; 
                        z-index:-1; 
                        visibility: hidden;

                        &:checked + label.custom-check {
                            &:after {
                                transform: translate(-50%, -50%);
                                opacity: 1;
                            }
                        }
                        
                        // Custom Field error styling
                        &:required {
                            &:not(:checked) {
                                &.invalid {
                                    +label {
                                        border: 1px solid $red;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .accept-and-send {
                margin-top:5px;

                @include breakpoint(frommediumlarge) {
                    display:flex;
                    align-items: center;
                    justify-content: space-between;
                }

                @include breakpoint(fromlarge) {
                    display:block;
                }

                @include breakpoint(extralarge) {
                    display:flex;
                    align-items: center;
                    justify-content: space-between;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue